import {ChangeDetectionStrategy, Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {EntityKeyService} from '@pma-entity/services/entity-key.service';
import {EntityDataLayoutService} from "@layout/layouts/entity-data/entity-data-layout.service";
import {ListPageComponentBase} from "@mojo-mci/list-page-component-base";

@Component({
    selector: 'mojo-vacant-list-page',
    templateUrl: './vacant-list-page.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class VacantListPageComponent
  extends ListPageComponentBase
  implements OnInit, OnDestroy {

  constructor(
    private readonly router: Router,
    entityKeyService: EntityKeyService,
    entityDataLayoutService: EntityDataLayoutService) {
    super(entityKeyService, entityDataLayoutService);
  }

  ngOnInit(): void {
    super.ngOnInit('Vacants');
  }

  handleRowSelect(data) {
    this.router.navigate([`/entity-data/property/${data['SystemPropertyRef']}/vacant/${data['SystemUnitKeyRef']}`]);
  }

  getRowHref = (row) => {
    return `/entity-data/property/${row['SystemPropertyRef']}/vacant/${row['SystemUnitKeyRef']}`;
  }
}
